export const enum CoverUploadStatus {
  INPROGRESS = 'inprogress',
  ERROR = 'error',
  NOT_STARTED = 'not-started',
  SUCCESS = 'success',
}
